"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection346sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-5 col-lg-12 col-md-6" | "col-xl-2 col-lg-4 col-md-6" | "col-xl-3 col-lg-4 col-md-6" */
    className: string;
    /** Detected variants: "footer-widget footer-about" | "footer-widget" */
    div0ClassName: string;
    /** Detected variants: "footer-logo mb-4" | "footer-support" */
    div0ClassName2?: string;
    /** Detected variants: "support-item mb-3" */
    div0ClassName3?: string;
    /** Detected variants: "avatar avatar-lg bg-secondary rounded-circle flex-shrink-0" */
    div0ClassName4?: string;
    /** Detected variants: "isax isax-location-tick4" */
    i0ClassName?: string;
    /** Detected variants: "1250 Sunset Boulevard, USA" */
    h50Text?: ReactNode;
    /** Detected variants: "link" */
    h50ClassName?: string;
    /** Detected variants: "Visit Our Clinic" */
    p0Text?: ReactNode;
    /** Detected variants: "title" */
    p0ClassName?: string;
    /** Detected variants: "support-item mb-3" */
    div1ClassName?: string;
    /** Detected variants: "avatar avatar-lg bg-secondary rounded-circle flex-shrink-0" */
    div0ClassName5?: string;
    /** Detected variants: "isax isax-messages-3" */
    i0ClassName2?: string;
    /** Detected variants: "link" */
    h50ClassName2?: string;
    /** Detected variants: "info@example.com" */
    link0Text?: ReactNode;
    /** Detected variants: "mailto:info@example.com" */
    href?: string;
    /** Detected variants: "General Inquiries" */
    p0P0Text?: ReactNode;
    /** Detected variants: "title" */
    p0ClassName2?: string;
    /** Detected variants: "support-item mb-3" */
    div2ClassName?: string;
    /** Detected variants: "avatar avatar-lg bg-secondary rounded-circle flex-shrink-0" */
    div0ClassName6?: string;
    /** Detected variants: "isax isax-call-calling" */
    i0ClassName3?: string;
    /** Detected variants: "+1 24565 89856" */
    h50H50Text?: ReactNode;
    /** Detected variants: "link" */
    h50ClassName3?: string;
    /** Detected variants: "Emergency Cases" */
    p0P0Text2?: ReactNode;
    /** Detected variants: "title" */
    p0ClassName3?: string;
    /** Detected variants: "logo" */
    alt?: string;
    /** Detected variants: "/Templates/Doccure/img/logo-08.svg" */
    src?: string;
    /** Detected variants: "footer-about-content mb-3" */
    div1ClassName2?: string;
    /** Detected variants: "We are a dedicated Eye Care and Vision Health Center committed to providing advanced, compassionate, and personalized treatment" */
    p0P0Text3?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName4?: string;
    /** Detected variants: "footer-available" */
    div2ClassName2?: string;
    /** Detected variants: "We Are Available !!" */
    h40Text?: ReactNode;
    /** Detected variants: "title" */
    h40ClassName?: string;
    /** Detected variants: "Monday - Friday : 8:30 AM to 6:30 PM" */
    p0P0Text4?: ReactNode;
    /** Detected variants: "date" */
    p0ClassName5?: string;
    /** Detected variants: "Company" | "Our Services" | "Keep in touch with us" */
    h50H50Text2?: ReactNode;
    /** Detected variants: "footer-title" */
    h50ClassName4?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Clinics" | "Hospitals" | "Specialities" | "Contact Us" | "Cataract Evaluation" | "Pediatric Eye Care" | "LASIK Surgery" | "Glaucoma Screening" | "Diabetic Eye Care" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.clinics" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.contactUs" | "#" */
    href: string;
    /** Detected variants: "isax isax-arrow-right-3" */
    className?: string;
};

type FooterSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "PERSONALIZED CARE PLANS" | "EXPERIENCED SPECIALISTS" */
    h20Text?: ReactNode;
    /** Detected variants: "fa-solid fa-circle" */
    className?: string;
    /** Detected variants: "services-slide" */
    divClassName?: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeEightFooterSectionGeneratedProps = {
    divDiv0Div0Div0Div1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection346sItem) => Partial<ComponentProps<"h5">>);
    divDiv0Div0Div1Div1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection346sItem) => Partial<ComponentProps<"h5">>);
    divDiv0Div0Div1Div1H50Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Div2Div1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection346sItem) => Partial<ComponentProps<"h5">>);
    divDiv0H50H5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection346sItem) => Partial<ComponentProps<"h5">>);
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "left" */
    footerDiv0DivDataDirection?: string;
    /** Default: "slow" */
    footerDiv0DivDataSpeed?: string;
    footerDiv1Div0Div0ClassName?: string;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv2Div0Div0Div0P0PText?: ReactNode;
    /** Default: "footer-bg" */
    footerDiv2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-1.png" */
    footerDiv2ImageWithBasePath0ImageSrc?: string;
    footerDiv2ImageWithBasePath0ImageVisible?: boolean;
    footerDiv2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer-bg" */
    footerDiv2ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-2.png" */
    footerDiv2ImageWithBasePath1ImageSrc?: string;
    footerDiv2ImageWithBasePath1ImageVisible?: boolean;
    footerDiv2ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv2ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection346s: FooterSection346sItem[];
    footerSectionServicesSlides: FooterSectionServicesSlidesItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSection346sItemWrapper?: (item: FooterSection346sItem, content: ReactNode) => ReactNode;
    footerSection346sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection346sLinkVisible?: boolean;
    footerSection346sLinkRenderer?: (item: FooterSection346sItem, defaultNode: ReactNode) => ReactNode;
    footerSection346sH5Visible?: boolean;
    footerSection346sH5Renderer?: (item: FooterSection346sItem, defaultNode: ReactNode) => ReactNode;
    footerSection346sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection346sH5Props?: Partial<ComponentProps<"h5">> | ((item: FooterSection346sItem) => Partial<ComponentProps<"h5">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesItemWrapper?: (item: FooterSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    footerSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH2Visible?: boolean;
    footerSectionServicesSlidesH2Renderer?: (item: FooterSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    footerSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: FooterSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkVisible?: boolean;
    footerSectionUls3LinkRenderer?: (item: FooterSectionUls3Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeEightFooterSectionGenerated: FC<HomeEightFooterSectionGeneratedProps> = ({
    footerDiv0DivDataDirection = "left",
    footerDiv0DivDataSpeed = "slow",
    footerDiv2Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv2ImageWithBasePath0ImageAlt = "footer-bg",
    footerDiv2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-1.png",
    footerDiv2ImageWithBasePath0ImageVisible,
    footerDiv2ImageWithBasePath0ImageRenderer,
    footerDiv2ImageWithBasePath0ImageProps,
    footerDiv2ImageWithBasePath1ImageAlt = "footer-bg",
    footerDiv2ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-2.png",
    footerDiv2ImageWithBasePath1ImageVisible,
    footerDiv2ImageWithBasePath1ImageRenderer,
    footerDiv2ImageWithBasePath1ImageProps,
    divDiv0Div0Div0Div1H50H5Props,
    divDiv0Div0Div1Div1H50H5Props,
    divDiv0Div0Div1Div1H50Link0LinkProps,
    divDiv0Div0Div2Div1H50H5Props,
    divDiv0H50H5Props,
    divH20H2Props,
    liLink0LinkProps,
    footerDiv1Div0Div0ClassName,
    footerSection346s,
    footerSectionServicesSlides,
    footerSectionUls3,
    footerSection346sItemWrapper,
    footerSection346sRenderer,
    footerSection346sLinkVisible,
    footerSection346sLinkRenderer,
    footerSection346sH5Visible,
    footerSection346sH5Renderer,
    footerSection346sLinkProps,
    footerSection346sH5Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionServicesSlidesItemWrapper,
    footerSectionServicesSlidesRenderer,
    footerSectionServicesSlidesH2Visible,
    footerSectionServicesSlidesH2Renderer,
    footerSectionServicesSlidesH2Props,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUls3LinkVisible,
    footerSectionUls3LinkRenderer,
    footerSectionUls3LinkProps,
}) => {
    return (
        <footer className="footer-eight footer position-relative">
            <div className="horizontal-slide slide-eight d-flex" data-direction={footerDiv0DivDataDirection} data-speed={footerDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        footerSectionServicesSlides,
                        (item: FooterSectionServicesSlidesItem) => (
                            <div className={item.divClassName ?? "services-slide"} key={item.key}>
                                {renderItemNode(footerSectionServicesSlidesH2Visible, footerSectionServicesSlidesH2Renderer, item, (
                                    <h2 {...(typeof footerSectionServicesSlidesH2Props === "function" ? footerSectionServicesSlidesH2Props(item) : (footerSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                ))}
                            </div>
                        ),
                        footerSectionServicesSlidesItemWrapper,
                        footerSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv1Div0Div0ClassName ?? "row g-md-5 g-4"}>
                        {renderCollectionNode(
                            footerSection346s,
                            (item: FooterSection346sItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName}>
                                        {renderItemNode(footerSection346sH5Visible, footerSection346sH5Renderer, item, (
                                            <h5 className={item.h50ClassName4} {...(typeof footerSection346sH5Props === "function" ? footerSection346sH5Props(item) : (footerSection346sH5Props ?? {}))} {...(typeof divDiv0H50H5Props === "function" ? divDiv0H50H5Props(item) : (divDiv0H50H5Props ?? {}))}>{item.h50H50Text2}</h5>
                                        ))}
                                        <div className={item.div0ClassName2}>
                                            <div className={item.div0ClassName3}>
                                                <div className={item.div0ClassName4}>
                                                    <i className={item.i0ClassName} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName}>{item.p0Text}</p>
                                                    {renderItemNode(footerSection346sH5Visible, footerSection346sH5Renderer, item, (
                                                        <h5 className={item.h50ClassName} {...(typeof footerSection346sH5Props === "function" ? footerSection346sH5Props(item) : (footerSection346sH5Props ?? {}))} {...(typeof divDiv0Div0Div0Div1H50H5Props === "function" ? divDiv0Div0Div0Div1H50H5Props(item) : (divDiv0Div0Div0Div1H50H5Props ?? {}))}>{item.h50Text}</h5>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className={item.div1ClassName}>
                                                <div className={item.div0ClassName5}>
                                                    <i className={item.i0ClassName2} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName2}>{item.p0P0Text}</p>
                                                    {renderItemNode(footerSection346sH5Visible, footerSection346sH5Renderer, item, (
                                                        <h5 className={item.h50ClassName2} {...(typeof footerSection346sH5Props === "function" ? footerSection346sH5Props(item) : (footerSection346sH5Props ?? {}))} {...(typeof divDiv0Div0Div1Div1H50H5Props === "function" ? divDiv0Div0Div1Div1H50H5Props(item) : (divDiv0Div0Div1Div1H50H5Props ?? {}))}>
                                                            {renderItemNode(footerSection346sLinkVisible, footerSection346sLinkRenderer, item, (
                                                                <SmartLink href={item.href ?? "#"} {...(typeof footerSection346sLinkProps === "function" ? footerSection346sLinkProps(item) : (footerSection346sLinkProps ?? {}))} {...(typeof divDiv0Div0Div1Div1H50Link0LinkProps === "function" ? divDiv0Div0Div1Div1H50Link0LinkProps(item) : (divDiv0Div0Div1Div1H50Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                            ))}
                                                        </h5>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className={item.div2ClassName}>
                                                <div className={item.div0ClassName6}>
                                                    <i className={item.i0ClassName3} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName3}>{item.p0P0Text2}</p>
                                                    {renderItemNode(footerSection346sH5Visible, footerSection346sH5Renderer, item, (
                                                        <h5 className={item.h50ClassName3} {...(typeof footerSection346sH5Props === "function" ? footerSection346sH5Props(item) : (footerSection346sH5Props ?? {}))} {...(typeof divDiv0Div0Div2Div1H50H5Props === "function" ? divDiv0Div0Div2Div1H50H5Props(item) : (divDiv0Div0Div2Div1H50H5Props ?? {}))}>{item.h50H50Text}</h5>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ),
                            footerSection346sItemWrapper,
                            footerSection346sRenderer
                        )}
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text">
                            <p className="mb-0">{footerDiv2Div0Div0Div0P0PText}</p>
                        </div>
                        <div className="social-icon">
                            <ul className="d-flex align-items-center gap-2 social-item">
                                {renderCollectionNode(
                                    footerSectionUls3,
                                    (item: FooterSectionUls3Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls3LinkVisible, footerSectionUls3LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof footerSectionUls3LinkProps === "function" ? footerSectionUls3LinkProps(item) : (footerSectionUls3LinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls3ItemWrapper,
                                    footerSectionUls3Renderer
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                {renderNode(footerDiv2ImageWithBasePath0ImageVisible, footerDiv2ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={footerDiv2ImageWithBasePath0ImageSrc} alt={footerDiv2ImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(footerDiv2ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv2ImageWithBasePath1ImageVisible, footerDiv2ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={footerDiv2ImageWithBasePath1ImageSrc} alt={footerDiv2ImageWithBasePath1ImageAlt} className="img-fluid shadow-2" {...(footerDiv2ImageWithBasePath1ImageProps ?? {})} />
                ))}
            </div>
        </footer>
    );
};

export default HomeEightFooterSectionGenerated;
